export class UsrGrp {
    public Id: number;
    public IdType: string;
    public Name: string;
}
